<template>
    <header>
        <div class="title-box">
            <h1>
                <span id="sampurasun-message">Sampurasun</span>
                <span id="name-message">I'm Jonathan.</span>
            </h1>
            <vue-typed-js :strings="typedStrings" :loop="true" :smartBackspace="true" :backSpeed="30" :typeSpeed="50" id="typed-message">
                <h2><span class="typing"></span></h2>
            </vue-typed-js>
        </div>
    </header>
</template>

<script>
export default {
    data() {
        return {
            typedStrings: ['This is me speaki', 'This is me typing', 'Human Computer Interaction student', 'UX enthusiast']
        }
    }
}
</script>

<style lang="scss" scoped>
header {
    height: 95vh;
    background-image: linear-gradient(to right bottom, rgba($colour-white, 0.4), rgba($colour-blue-primary, 0.8)), 
                    url(/assets/homepage.jpg);
    background-size: cover;
    background-position: top right;
    background-attachment: fixed;
    position: relative;

    .title-box {
        position: absolute;
        top: 35vh;
        left: 15vw;

        h1 {
            color: $colour-blue-dark;
            animation: enterFromLeft 2s;

            span {
                display: block;
            }

            #sampurasun-message {
                text-transform: uppercase;
                font-size: 0.5em;
            }

            #name-message {
                font-weight: 700;
                font-size: 1.2em;
                color: $colour-blue-dark;
            }
        }

        #typed-message {
            display: inline-block;
            margin-top: 1%;
            text-transform: uppercase;

            h2 {
                font-size: 1.2em;
                font-weight: 300;
                animation: fadeIn 5s;
                color: $colour-grey-dark;
            }
        }
    }
}

.typed-cursor {
    opacity: 0.4!important;
}
</style>
